import preFetchImage from './preFetchImage';

const preFetchMarketingImages = (moduleGroups) =>
  moduleGroups.forEach((group) =>
    // eslint-disable-next-line camelcase
    group.moduleViews.forEach(({ images_by_dimension }) => {
      const src =
        images_by_dimension['177x132'] ||
        images_by_dimension['570x324'] ||
        images_by_dimension['354x302'] ||
        images_by_dimension['184x115'];
      if (src) preFetchImage(src);
    })
  );

export default preFetchMarketingImages;
